export const ORDER_EXPRESS_SHIPPING_DESTINATIONS = 'ORDER_EXPRESS_SHIPPING_DESTINATIONS';

export const DISPATCH_SUB_ORDER_LIST_KEY = 'DISPATCH_SUB_ORDER_LIST_KEY';
export const DISPATCH_PRODUCT_LIST_KEY = 'DISPATCH_PRODUCT_LIST_KEY';
export const DISPATCH_WAREHOUSE_LIST_KEY = 'DISPATCH_WAREHOUSE_LIST_KEY';

export const ORDER_PAYMENT_TRACES_KEY = 'ORDER_PAYMENT_TRACES_KEY';
